import Icon from '../components/Icon.vue'

Icon.register({"times":{"width":384,"height":512,"paths":[{"d":"M323.1 441L377 387.1C386.4 377.7 386.4 362.6 377 353.2L279.8 256 377 158.8C386.4 149.4 386.4 134.3 377 124.9L323.1 71C313.7 61.6 298.6 61.6 289.2 71L192 168.2 94.8 71C85.4 61.6 70.3 61.6 60.9 71L7 124.9C-2.4 134.3-2.4 149.4 7 158.8L104.2 256 7 353.2C-2.4 362.6-2.4 377.7 7 387.1L60.9 441C70.3 450.4 85.4 450.4 94.8 441L192 343.8 289.2 441C298.5 450.3 313.7 450.3 323.1 441z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/times.js
// module id = null
// module chunks = 